"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _deepmerge = _interopRequireDefault(require("deepmerge"));

var _gerenciatdAdabyronCloud = require("@bit/gerenciatd.adabyron-cloud.customizer");

var _gerenciatdUtils = require("@bit/gerenciatd.utils.constants");

var _gerenciatdUtils2 = require("@bit/gerenciatd.utils.common");

var _gerenciatdUtils3 = require("@bit/gerenciatd.utils.context");

var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.tagged-component"));

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

class CustomizerComponent extends _react.Component {
  constructor(props) {
    super(props);

    _defineProperty(this, "onCompleteHandler", (status, activityId) => {
      const {
        onComplete
      } = this.props;

      if (onComplete && (status === _gerenciatdUtils.NETWORK_STATUS.ERROR || status === _gerenciatdUtils.NETWORK_STATUS.SUCCESS)) {
        onComplete({
          activityId
        });
      }
    });

    _defineProperty(this, "searchForCreativitiesIds", custoObj => {
      const dotNotation = [];

      if (typeof custoObj === 'object') {
        Object.keys(custoObj).forEach(internalCustoObj => {
          if (internalCustoObj === 'taggingInfo') {
            return;
          }

          const dotNotationRoot = `${internalCustoObj}`;
          const dotNotationArray = this.searchForCreativitiesIds(custoObj[internalCustoObj]);
          const dotNotationFinalArray = [];
          let dotNotationString = '';
          dotNotationArray.forEach(notation => {
            dotNotationString = `${dotNotationRoot}.${notation.key}`;
            dotNotationFinalArray.push(_objectSpread(_objectSpread({}, notation), {}, {
              key: dotNotationString
            }));
          });

          if (dotNotationFinalArray.length > 0) {
            dotNotation.push(...dotNotationFinalArray);
          } else {
            if (dotNotationRoot === 'creaName') {
              dotNotation.push({
                key: dotNotationRoot,
                value: custoObj[dotNotationRoot]
              });
            }
          }
        });
      }

      return dotNotation;
    });

    _defineProperty(this, "applyTransform2ObjectRecursivity", input => {
      const isAnObject = input && typeof input === 'object' && !(input instanceof RegExp);
      const myInput = isAnObject ? input : {};
      const keys = Object.keys(myInput);
      const res = isAnObject ? {} : input;
      keys.forEach(key => {
        let currentValue = myInput[key];
        const currentValueType = typeof currentValue;

        if (currentValue && currentValue['$$typeof'] && currentValue['$$typeof'].toString() === 'Symbol(react.element)') {
          res[key] = currentValue;
        } else if (currentValueType === 'object' && !Array.isArray(currentValue)) {
          res[key] = this.applyTransform2ObjectRecursivity(currentValue);
        } else if (currentValueType === 'object' && Array.isArray(currentValue)) {
          currentValue = currentValue.filter((v, i, a) => a.findIndex(t => JSON.stringify(t) === JSON.stringify(v)) === i);
          res[key] = currentValue.map(arrayItem => {
            return this.applyTransform2ObjectRecursivity(arrayItem);
          });
        } else {
          res[key] = currentValue;
        }
      });
      return res;
    });

    _defineProperty(this, "requestDataForActivity", (icParams, activityId) => {
      const fullCustoObj = _objectSpread(_objectSpread({}, icParams), {}, {
        name: activityId
      });

      this.setState({
        status: _gerenciatdUtils.NETWORK_STATUS.FETCHING
      });
      (0, _gerenciatdAdabyronCloud.getByName)(fullCustoObj).then(({
        response
      }) => {
        if (response.error) {
          this.setState({
            status: _gerenciatdUtils.NETWORK_STATUS.ERROR
          });
          this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.ERROR, activityId);
        } else {
          this.custoData.dotNotationToBuild = this.searchForCreativitiesIds(response);
          const newComponentData = (0, _deepmerge.default)(response, this.custoData.componentData);
          this.custoData.componentData = this.applyTransform2ObjectRecursivity(newComponentData);
          this.custoData.creasToResolve = this.custoData.dotNotationToBuild.length;
          this.custoData.dotNotationToBuild.forEach(dotNotationObj => {
            this.requestDataForCreativity(icParams, dotNotationObj.value, dotNotationObj.key);
          });

          if (this.custoData.dotNotationToBuild && this.custoData.dotNotationToBuild.length === 0) {
            this.setState({
              componentData: this.custoData.componentData,
              status: _gerenciatdUtils.NETWORK_STATUS.SUCCESS
            });
            this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.SUCCESS, activityId);
          }
        }
      }).catch(() => {
        this.setState({
          status: _gerenciatdUtils.NETWORK_STATUS.ERROR
        });
        this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.ERROR, activityId);
      });
    });

    _defineProperty(this, "updateObjProp", (obj, value, propPath) => {
      const [head, ...rest] = propPath.split('.');
      !rest.length ? obj[head] = value : this.updateObjProp(obj[head], value, rest.join('.'));
    });

    _defineProperty(this, "requestDataForCreativity", (icParams, creativityId, dotNotationString) => {
      const fullCustoObj = _objectSpread(_objectSpread({}, icParams), {}, {
        name: creativityId
      });

      (0, _gerenciatdAdabyronCloud.getByName)(fullCustoObj, 'creativity').then(({
        response
      }) => {
        if (response.error) {
          this.setState({
            status: _gerenciatdUtils.NETWORK_STATUS.ERROR
          });
          this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.ERROR, creativityId);
        } else {
          const dotNotationStringFinal = dotNotationString.replace('.creaName', '');
          this.updateObjProp(this.custoData.componentData, response, dotNotationStringFinal);
          this.custoData.creasToResolve -= 1;

          if (this.custoData.creasToResolve === 0) {
            this.setState({
              componentData: this.custoData.componentData,
              status: _gerenciatdUtils.NETWORK_STATUS.SUCCESS
            });
            this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.SUCCESS, creativityId);
          }
        }
      }).catch(() => {
        this.setState({
          status: _gerenciatdUtils.NETWORK_STATUS.ERROR
        });
        this.onCompleteHandler(_gerenciatdUtils.NETWORK_STATUS.ERROR, creativityId);
      });
    });

    _defineProperty(this, "componentDidMount", () => {
      const {
        spaId,
        activityId,
        dataMock,
        component,
        onComplete,
        customProps
      } = this.props;

      if (!dataMock && component) {
        (0, _gerenciatdUtils3.mapContextParamsToCustoReq)(`${spaId}-${activityId}-${(0, _gerenciatdUtils2.giveRandomNumber)(1, 999)}`, icParams => {
          if (icParams && icParams.i3Ready || process.env.NODE_ENV === 'development') {
            this.requestDataForActivity(icParams, activityId);
          }
        });
      }

      if (dataMock && component) {
        const {
          status,
          componentData
        } = dataMock;
        this.setState({
          componentData: (0, _deepmerge.default)(componentData, customProps),
          status
        });

        if (onComplete && (status === _gerenciatdUtils.NETWORK_STATUS.ERROR || status === _gerenciatdUtils.NETWORK_STATUS.SUCCESS)) {
          onComplete({
            activityId
          });
        }
      }
    });

    const {
      customProps: _customProps
    } = props;
    this.custoData = {
      componentData: _customProps,
      dotNotationToBuild: [],
      nestingLevel: 0,
      creasToResolve: 0
    };
    this.state = {
      status: null,
      componentData: null
    };
  }

  render() {
    const {
      activityId,
      component: MyComponent,
      singleton,
      componentName,
      isCustomizable
    } = this.props;
    const {
      status,
      componentData
    } = this.state;

    if (!MyComponent) {
      return null;
    }

    const id = componentName || activityId;
    let finalTaggingInfo = {};

    if (componentData && componentData.taggingInfo) {
      finalTaggingInfo = _objectSpread({}, componentData.taggingInfo);
    }

    finalTaggingInfo.componentName = id; // Customizable component

    if (isCustomizable) {
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_gerenciatdUnifiedcomponents.default, {
        id: id,
        customizerId: activityId,
        WaitingComponent: MyComponent && MyComponent.WaitingComponent || (() => null),
        status: status,
        taggingInfo: finalTaggingInfo,
        visible: componentData && componentData.visible || true,
        children: [componentData && singleton && /*#__PURE__*/(0, _jsxRuntime.jsx)(MyComponent, _objectSpread(_objectSpread({}, componentData), {}, {
          taggingInfo: _objectSpread(_objectSpread({}, componentData.taggingInfo), {}, {
            componentName: finalTaggingInfo.componentName
          }),
          singleton: singleton
        })), componentData && !singleton && /*#__PURE__*/(0, _jsxRuntime.jsx)(MyComponent, _objectSpread(_objectSpread({}, componentData), {}, {
          taggingInfo: _objectSpread(_objectSpread({}, componentData.taggingInfo), {}, {
            componentName: finalTaggingInfo.componentName
          })
        }))]
      }, activityId);
    } // Non Customizable component


    return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: "nonCustomizableComponent",
      children: [componentData && singleton && /*#__PURE__*/(0, _jsxRuntime.jsx)(MyComponent, _objectSpread(_objectSpread({}, componentData), {}, {
        taggingInfo: _objectSpread(_objectSpread({}, componentData.taggingInfo), {}, {
          componentName: finalTaggingInfo.componentName
        }),
        singleton: singleton
      })), componentData && !singleton && /*#__PURE__*/(0, _jsxRuntime.jsx)(MyComponent, _objectSpread(_objectSpread({}, componentData), {}, {
        taggingInfo: _objectSpread(_objectSpread({}, componentData.taggingInfo), {}, {
          componentName: finalTaggingInfo.componentName
        })
      }))]
    });
  }

}

CustomizerComponent.propTypes = {
  spaId: _propTypes.default.string.isRequired,
  activityId: _propTypes.default.string.isRequired,
  componentName: _propTypes.default.string,
  component: _propTypes.default.node.isRequired,
  singleton: _propTypes.default.node,
  dataMock: _propTypes.default.shape({
    status: _propTypes.default.oneOf([_gerenciatdUtils.NETWORK_STATUS.FETCHING, _gerenciatdUtils.NETWORK_STATUS.SUCCESS, _gerenciatdUtils.NETWORK_STATUS.ERROR]),
    component: _propTypes.default.node,
    componentData: _propTypes.default.object
  }),
  onComplete: _propTypes.default.func,

  /**
   * {
   *  "info": "Objeto con propiedades a enviar desde la aplicación,
   *  tienen mayor peso que las obtenidas desde customizer",
   *  "kind": "both",
   *  "beautifulName": "customProps"
   * }
   */
  customProps: _propTypes.default.object,
  isCustomizable: _propTypes.default.bool
};
CustomizerComponent.defaultProps = {
  dataMock: null,
  onComplete: null,
  singleton: null,
  customProps: {},
  componentName: null,
  isCustomizable: true
};
var _default = CustomizerComponent;
exports.default = _default;

//# sourceMappingURL=index.js.map